export default __webpack_public_path__ + "static/media/img-bg-grid.90678d02.svg";